export default __webpack_public_path__ + "static/media/coverJAB_small.c2846232.jpg";